export const COMMENT_NAME = /@\[(.+)]\(\d+\)/g;
